<template>
  <b-container>
    <b-row>
      <b-col>
        <b-card id="loginCard" class="text-center mx-auto">
          <b-row>
            <b-col>
              <h2 class="text-info">{{ $t("globals.billing") }}</h2>
            </b-col>
          </b-row>
          <hr />
          <b-row class="my-2">
            <b-col>
              <b-input
                v-model="email"
                type="text"
                :placeholder="$t('globals.email')"
              >
              </b-input>
            </b-col>
          </b-row>
          <b-row class="my-2">
            <b-col>
              <b-input
                v-model="pass"
                @keyup.enter="callLogin"
                type="password"
                :placeholder="$t('globals.password')"
              >
              </b-input>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <b-btn
                variant="info"
                @click="callLogin"
                :disabled="loginDisabled"
              >
                {{ $t("globals.login") }}
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="text-center text-secondary">{{ getLoginInfo }}</p>
      </b-col>
    </b-row>
    <ulu-loading />
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    "ulu-loading": () => import("@/components/Loading")
  },
  data() {
    return {
      email: "",
      pass: ""
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    callLogin() {
      if (!this.loginDisabled) {
        this.login({ email: this.email, password: this.pass });
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["getLoginInfo"]),
    loginDisabled() {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !(this.pass.length !== 0 && re.test(String(this.email)));
    }
  }
};
</script>

<style scoped>
#loginCard {
  max-width: 25rem;
  margin-top: 15rem;
}
</style>
